import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { textFieldProps } from "../../../shared/constants";
import { useState } from "react";
import { functions } from "../../../../firebase";
import { httpsCallable } from "firebase/functions";

export default function RunManualDateBluElectricity({ open, close }) {
  const [runDate, setRunDate] = useState("");
  const [busy, setBusy] = useState(false);

  const handleManualReport = async () => {
    const manualRunBluElectricityReport = httpsCallable(
      functions,
      "manualRunBluElectricityReport"
    );
    setBusy(true);
    await manualRunBluElectricityReport({ selectedDate: runDate });
    setBusy(false);
  };

  const handleClose = () => {
    close();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Run Blu Electricity Report Manually</DialogTitle>
      <DialogContent>
        <TextField
          {...textFieldProps}
          label="Date (DD/MM/YYYY)"
          onChange={(e) => setRunDate(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="error">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleManualReport}
          disabled={busy}
        >
          Execute
        </Button>
      </DialogActions>
    </Dialog>
  );
}
